export const QA_NAME_BUILDING_CREATION_MODAL = 'create_building'
